<h1 class="page-title mb-5">عن مصر</h1>
<div>
  <div>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <div class="container">
          <div class="card shadow-sm">
            <div class="card-body">
              <table class="table table-bordered table-striped text-center align-middle">
                <tbody>
                  <tr *ngFor="let item of countryData">
                    <th class="col-4">{{ item.label }}</th>
                    <td class="col-8">
                      <ng-container *ngIf="item.type === 'image'; else textValue">
                        <img [src]="item.value" alt="{{ item.label }}" class="flag-img" />
                      </ng-container>
                      <ng-template #textValue>{{ item.value }}</ng-template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <app-fix-left-section></app-fix-left-section>
      </div>
    </div>
  </div>
</div>